(function($, undefined) {
	
	'use strict';

	var changePageVar = function() {
		var t = $(this);
		updateLabelLangs(t.attr('name'), t.val(), $('html').attr('data-all-langs'), null, true);
	};

	var toggleRadioWarnings = function() {
		var t = $(this);
		var ctn = t.closest('.settings-master-checkbox-ctn');
		var outerCtn = t.closest('.radio-btns-ctn');

		outerCtn.find('.element-to-toggle.radio').slideUp();
		ctn.find('.element-to-toggle.radio').slideDown();
	};

	var init = function () {
		$('.change-page-var').focusout(changePageVar);
		$('.settings-master-radio-toggle').change(toggleRadioWarnings);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
